import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../../hooks/useApi";
import LineBtn from "../../../../../Button/LineBtn";
import FixedInfoBox from "../../../../../DefaultStyles/FixedInfoBox";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import {
  ModalSection,
  ModalSectionLabel,
} from "../../../PartyDetail/PartyExitModal/PartyExitModal";
import { recentChatBtnClick } from "../../ChatSearch/ChatSearchResult";
import { chatTabState } from "../../ChatTab";
import ChatReportRegisterModal from "../ChatReportRegisterModal/ChatReportRegisterModal";
import { IChatReportComplete } from "../ReportComplete";
import { decryptChat } from "../../../../../../ApiTS/web/ApiChatTS";
import Loader from "../../../../../DefaultStyles/Loader";
import { isNewChat } from "../../../../../../pages/Party/ChatInfo";
import { reportReasonList } from "../ChatReport";
import { getSubsNameBySubsId3 } from "../../../../../../AdminApi/3.0_utils";

interface ChatReportDetailModalProps {
  closeEvent: () => void;
  comfirmEvent?: () => void;
  data: IChatReportComplete;
  isChatReportCompleteModal?: boolean;
}

interface IDetailReportedChat {
  date: string;
  message: string;
  messageId: number;
}

export default function ChatReportDetailModal({
  closeEvent,
  data,
  isChatReportCompleteModal,
}: ChatReportDetailModalProps) {
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  const navigate = useNavigate();
  const [reportRegisterModal, setReportRegisterChat] = useState(false);

  console.log(data);

  // 채팅 신고 메세지 조회
  const { response, loading } = useApi({
    method: "get",
    url: data?.id
      ? `${isNewChat ? "chat" : "oldchat"}/report/${data?.id}`
      : undefined,
  });

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      modalTitle={
        isChatReportCompleteModal
          ? "채팅 신고 처리 완료"
          : "채팅 신고 내용 및 접수"
      }
      confirmEvent={() => {
        if (isChatReportCompleteModal) {
          closeEvent();
        } else {
          setReportRegisterChat(true);
        }
      }}
      leftBottomTime={data?.comptime ?? ""}
      leftBottomName={data?.admin ?? ""}
      confirmBtnText={isChatReportCompleteModal ? "닫기" : "신고 접수"}
      leftBottomBtn={
        isChatReportCompleteModal ? undefined : (
          <LineBtn
            btnText="관련 채팅 보기"
            icon="launch"
            btnHeight={38}
            btnClickEvent={() => {
              setTab(1);
              setRecentBtnClick(true);
              navigate({
                pathname: `/party/chat`,
                search: `${data?.party?.partyid}@${data?.party?.ownerid}@${
                  String(data?.party?.ownerid) === data?.user?.uid
                    ? data?.target?.uid
                    : data?.user?.uid
                }`,
              });
            }}
          />
        )
      }
      cancelBtn={
        isChatReportCompleteModal ? (
          <LineBtn
            btnText="관련 채팅 보기"
            icon="launch"
            btnHeight={38}
            btnClickEvent={() => {
              setTab(1);
              setRecentBtnClick(true);
              navigate({
                pathname: `/party/chat`,
                search: `${data?.party?.partyid}@${data?.party?.ownerid}@${
                  String(data?.party?.ownerid) === data?.uid?.uid
                    ? data?.target?.uid
                    : data?.uid?.uid
                }`,
              });
            }}
          />
        ) : undefined
      }
    >
      {/* 신고자 */}
      <ModalSection>
        <ModalSectionLabel>신고자</ModalSectionLabel>

        <ValueContainer>
          <div
            style={{ flex: 2 }}
            onClick={() =>
              window.open(`/users/info/${data?.user?.uid}`, "_blank")
            }
          >
            <FixedInfoBox
              label="UID"
              value={`${data?.user?.uid}_${data?.user?.name}_${data?.user?.nickname}`}
              hasArrow={true}
              padding="11px 8px 11px 16px"
            />
          </div>

          <div style={{ flex: 1 }}>
            <FixedInfoBox
              label="구분"
              value={
                String(data?.party?.ownerid) === data?.user?.uid
                  ? "파티장"
                  : "파티원"
              }
              sHeight={62.5}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 신고 대상 */}
      <ModalSection>
        <ModalSectionLabel>신고 대상</ModalSectionLabel>

        <ValueContainer>
          <div
            style={{ flex: 2 }}
            onClick={() =>
              window.open(`/users/info/${data?.target?.uid}`, "_blank")
            }
          >
            <FixedInfoBox
              label="UID"
              value={`${data?.target?.uid}_${data?.target?.name}_${data?.target?.nickname}`}
              hasArrow={true}
              padding="11px 8px 11px 16px"
            />
          </div>

          <div style={{ flex: 1 }}>
            <FixedInfoBox
              label="구분"
              value={
                String(data?.party?.ownerid) === data?.target?.uid
                  ? "파티장"
                  : "파티원"
              }
              sHeight={62.5}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 파티 정보 */}
      <ModalSection>
        <ModalSectionLabel>파티 정보</ModalSectionLabel>

        <ValueContainer>
          <div style={{ flex: 1 }}>
            <FixedInfoBox label="PID" value={data?.party?.partyid} />
          </div>

          <div style={{ flex: 2 }}>
            <FixedInfoBox
              label="Subscription"
              value={`${data?.party?.servsubsid}_${getSubsNameBySubsId3(
                data?.party?.servsubsid
              )}`}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 사유 */}
      <ModalSection>
        <ModalSectionLabel>사유</ModalSectionLabel>

        <ValueContainer>
          <FixedInfoBox
            label="사유 구분"
            value={
              data?.reasonid === 5
                ? data?.reason
                : reportReasonList?.find((r) => r.id === data?.reasonid)?.text
            }
          />
        </ValueContainer>
      </ModalSection>

      {/* 신고 Msg_ID */}
      <ModalSection>
        <ModalSectionLabel>신고 Msg</ModalSectionLabel>

        <ValueContainer style={{ flexDirection: "column" }}>
          {response?.data?.map((d: IDetailReportedChat) => {
            return (
              <FixedInfoBox
                label={d.date}
                value={decryptChat(d?.message ?? "")}
                padding={"16px"}
              />
            );
          })}
        </ValueContainer>
      </ModalSection>

      {/* 신고 일시 */}
      <ModalSection>
        <ModalSectionLabel>신고 일시</ModalSectionLabel>

        <ValueContainer>
          <FixedInfoBox value={data?.time} sHeight={38} />
        </ValueContainer>
      </ModalSection>

      {/* 처리 내용 */}
      <>
        {isChatReportCompleteModal && (
          <ModalSection>
            <ModalSectionLabel>처리 내용</ModalSectionLabel>

            <ValueContainer>
              <FixedInfoBox value={data?.comment} />
            </ValueContainer>
          </ModalSection>
        )}
      </>

      <>
        {reportRegisterModal && (
          <ChatReportRegisterModal
            closeEvent={() => {
              setReportRegisterChat(false);
            }}
            confirmEvent={() => closeEvent()}
            chatKey={data?.id}
          />
        )}
      </>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}

const ValueContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
